import { AxiosRequestConfig } from 'axios'
import { trackPromise } from 'react-promise-tracker'

import api from 'utils/api'
import { ApiResponse } from 'utils/types'

const headerConfig: AxiosRequestConfig = {
  responseType: 'arraybuffer',
}

const url = '/v1/financial/report'
const Api = {
  financial: (request: any): Promise<any> => trackPromise<ApiResponse>(api.post(`${url}/financial`, request, headerConfig)),
  expenseByClient: (request: any): Promise<any> => trackPromise<ApiResponse>(api.post(`${url}/expense-by-client`, request, headerConfig)),
}

export default Api
